module.exports = __webpack_public_path__ + "img/198.6c9d0a08.png";